/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import { DashboardPlugin, ClientInitPlugin, InitClientMixin } from './plugins';
import App from './App.vue';

import api from './services/api.service';

// router setup
import router from './routes/router';
// plugin setup
Vue.use(DashboardPlugin);

import ServiceFactory from '@/services/service.factory';

Vue.prototype.$services = ServiceFactory;

const packageJson = require('../package.json');

Vue.prototype.$version = packageJson.version;
Vue.prototype.$lastUpdate = packageJson.date;

import { abilitiesPlugin } from '@casl/vue';
import ability from '@/guards/ability';

Vue.use(abilitiesPlugin, ability);

import store from './store';

store.$services = ServiceFactory;

Vue.use(ClientInitPlugin);

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  mixins: [InitClientMixin],
  render: (h) => h(App),
  router,
});
